import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Level } from '../../models/common.model';

@Component({
  selector: 'gt-level-badge',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './level-badge.component.html',
  styleUrls: ['./level-badge.component.scss'],
})
export class LevelBadgeComponent {
  @Input() level: Level = 'ROOKIE';

  get filledStars(): number {
    const starsMap: Record<Level, number> = {
      ROOKIE: 1,
      EXPERT: 2,
      PRO: 3,
      LEGEND: 4,
      ORGANIZATION: 0,
    };
    return starsMap[this.level];
  }

  get emptyStars(): number {
    return 4 - this.filledStars;
  }

  get bgColorClass(): string {
    const colorMap: Record<Level, string> = {
      ROOKIE: 'bg-rookie',
      EXPERT: 'bg-expert',
      PRO: 'bg-pro',
      LEGEND: 'bg-legend',
      ORGANIZATION: 'bg-organization',
    };
    return colorMap[this.level];
  }

  getFilledStarArray(): number[] {
    return Array(this.filledStars).fill(0);
  }

  getEmptyStarArray(): number[] {
    return Array(this.emptyStars).fill(0);
  }
}
